import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AnimatePresence } from 'framer-motion'

// Actions
import { actions as surveyActions } from 'modules/interestform/actions'

// Components
import MultiStepForm from 'components/interestform/multistepform'
import WelcomeToTracklib from 'components/interestform/slides/welcometotracklib'
import PresentationOptions from 'components/interestform/slides/presentationoptions'
import ThisIsTracklib from 'components/interestform/slides/thisistracklib'
import ThisIsSampling from 'components/interestform/slides/thisissampling'
import WhatWeDo from 'components/interestform/slides/whatwedo'
import SourcesOfIncome from 'components/interestform/slides/sourcesofincome'
import Subscription from 'components/interestform/slides/subscription'
import Discovery from 'components/interestform/slides/discovery'
import Licensing from 'components/interestform/slides/licensing'
import SampleClassification from 'components/interestform/slides/sampleclassification'
import LicensePricing from 'components/interestform/slides/licensepricing'
import DeliverMore from 'components/interestform/slides/delivermore'
import Artists from 'components/interestform/slides/artists'
import Videos from 'components/interestform/slides/videos'
import WhatHappensNow from 'components/interestform/slides/whathappensnow'
import CatalogInformation from 'components/interestform/slides/cataloginformation'
import RightsInformation from 'components/interestform/slides/rightsinformation/rightsinformation'
import ContactInformation from 'components/interestform/slides/contactinformation'
import ReviewInformation from 'components/interestform/slides/reviewinformation'
import ThankYou from 'components/interestform/slides/thankyou'

// Hooks
import { useRequest } from 'modules/requests/hooks'
import { useDistributorList } from 'modules/interestform/hooks'

// Utils
import uniqueId from 'lodash/uniqueId'

import styles from './interestform.css'

const initialValues = {
  label_artist_name: '',
  links: [
    {
      id: uniqueId(),
      link: '',
    },
  ],
  distributor: '',
  other_distributor: '',
  master_rights_name: '',
  master_rights_email: '',
  publishing_owner: 'self_owned',
  publishing_rights_name: '',
  publishing_rights_email: '',
  first_name: '',
  last_name: '',
  personal_email: '',
  skipped_presentation: false,
  confirmed: false,
}

const InterestForm = () => {
  const dispatch = useDispatch()
  const fetchDistributorsRequest = useRequest('FETCH_DISTRIBUTORS')
  const distributorList = useDistributorList()

  useEffect(() => {
    if (distributorList.length <= 1 && !fetchDistributorsRequest.isLoading) {
      dispatch(surveyActions.fetchDistributors())
    }
  })

  return (
    <>
      <div className={styles.mainWrapper}>
        <AnimatePresence>
          <MultiStepForm initialValues={initialValues} onSubmit={values => dispatch(surveyActions.submitInterest(values))}>
            <WelcomeToTracklib />
            <PresentationOptions />
            <ThisIsTracklib />
            <ThisIsSampling />
            <WhatWeDo />
            <SourcesOfIncome />
            <Subscription />
            <Discovery />
            <Licensing />
            <SampleClassification />
            <LicensePricing />
            <DeliverMore />
            <Artists />
            <Videos />
            <WhatHappensNow />
            <CatalogInformation distributorOptions={distributorList} />
            <RightsInformation />
            <ContactInformation />
            <ReviewInformation distributorOptions={distributorList} />
            <ThankYou />
          </MultiStepForm>
        </AnimatePresence>
      </div>
    </>
  )
}

export default InterestForm
